<template lang="pug">
  .distributor-locator
    .distributor-locator__background.lazyload.image--fade-in(v-lazy:background-image="image")
    .distributor-locator__gradient-overlay
    .distributor-locator__container.container
      .distributor-locator__form-container
        .distributor-locator__form-header
          p.distributor-locator__form-pre-heading(v-if="settings.preHeading") {{ settings.preHeading }}
          h1.distributor-locator__form-heading {{ settings.heading }}
          p.distributor-locator__form-description(v-if="settings.description") {{ settings.description }}
        .distributor-locator__form-wrapper
          form.distributor-locator__form(@submit="findDistributor")
            .distributor-locator__form-inputs
              .distributor-locator__form-input-wrapper.form__input-wrapper
                label.distributor-locator__input-label Shop Name*
                input.distributor-locator__input.form__field.form__field--text(
                  type="text"
                  required
                  placeholder="Shop Name" 
                  v-model="shopName"
                  v-on:keyup.enter="findDistributor"
                )
              .distributor-locator__form-input-wrapper.form__input-wrapper
                label.distributor-locator__input-label Zip Code*
                input.distributor-locator__input.form__field.form__field--text(
                  type="text"
                  pattern="[0-9]{5}"
                  required
                  placeholder="Enter Zip Code"
                  v-model="zipCode"
                  v-on:keyup.enter="findDistributor"
                )
            template(v-if="!dataLoaded")
              button.distributor-locator__form-submit.button.button--primary(
                type="submit"
              ) {{ ctaText }}
          template(v-if="dataLoaded")
            .distributor-locator__search-results
              .distributor-locator__search-results-heading {{ searchResultsHeading }}
              template(v-if="!distributorFound")
                .distributor-locator__search-results-distributors
                  p.distributor-locator__search-results-none
                    span Please Call Us at&nbsp;
                    a(:href="`tel:+${settings.phoneNumber}`" class="phone-number") {{ settings.displayPhoneNumber }}&nbsp;
                    span to locate your nearest distributor.
                  .distributor-locator__search-results-button-wrapper
                    a.distributor-locator__search-results-primary-btn.button.button--primary(:href="settings.noResultCtaLink1") {{ settings.noResultCtaText1 }}
                    a.distributor-locator__search-results-secondary-btn.button.button--secondary(:href="settings.noResultCtaLink2") {{ settings.noResultCtaText2 }}
              template(v-else)
                .distributor-locator__search-results-distributors
                  .distributor-locator__search-results-shop-name
                    span Name:&nbsp;
                    span {{ distributor.distributor_name }}
                  .distributor-locator__search-results-email
                    span Email:&nbsp;
                    a(:href="`mailto:${distributor.distributor_email}`") {{ distributor.distributor_email }}
            button.distributor-locator__reset-search(type="button" @click="resetSearch") Reset Search
</template>

<script>
  export default {
    name: 'DistributorLocator',
    props: {
      settings: {
        type: Object,
        default: () => ({
          preHeading: String,
          heading: String,
          description: String,
          ctaText: String,
          requestToken: String,
          requestUrl: String
        })
      },
    },
    data() {
      return {
        shopName: '',
        zipCode: '',
        distributor: {},
        loadingData: false,
        dataLoaded: false
      }
    },
    computed: {
      image(){
        return this.isMobile && !!this.settings.backgroundImageMobile ? this.settings.backgroundImageMobile : this.settings.backgroundImage;
      },
      isMobile() {
        return ['mobile', 'tablet'].includes(this.$mq);
      },
      distributorFound() {
        return !!this.distributor.distributor_name || !!this.distributor.distributor_email;
      },
      searchResultsHeading() {
        return this.distributorFound ? 'Your distributor is:' : 'There are no distributors in your area:'
      },
      ctaText() {
        return this.loadingData ? "Loading..." : this.settings.ctaText;
      }
    },
    methods: {
      async findDistributor(e) {

        e.preventDefault();

        if(!this.shopName || !this.zipCode) return false;

        let url = this.settings.requestUrl;
        let token = this.settings.requestToken;
        let data = JSON.stringify({
          "shopName": this.shopName,
          "zipCode": this.zipCode
        });

        this.loadingData = true;

        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'token': token,
              'mode': 'cors',
            },
            body: data,
          });

          this.distributor = await response.json();
          this.loadingData = false;
          this.dataLoaded = true;

          if (!this.distributorFound) {
            throw new Error('Missing distributor_name or distributor_email property');
          }

        } catch (error) {
          console.error(error);
          this.distributor = {};
        }
      },
      resetSearch() {
        this.dataLoaded = false;
        this.distributor = {};
        this.shopName = '';
        this.zipCode = '';
      }
    }
  }
</script>
